module.exports = __webpack_public_path__ + "img/EMT-PRCA_10X_ACC.d9fe29a7.png";